// extracted by mini-css-extract-plugin
module.exports = {"des":"formLayout_des__2ldmZ","content":"formLayout_content__3Iv1x","inputdemo":"formLayout_inputdemo__2OnF2","sm":"formLayout_sm__1bo84","lg":"formLayout_lg__2cmuk"};